import ResourceBlockContainer from './ResourceBlockContainer';

globalThis.ResourceComponents = {
  ResourceBlockContainer,
};
